module.exports = __webpack_public_path__ + "img/34_37.04794b5d.png";